"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_ACTIVITY = void 0;
var SINGLE_ACTIVITY = {
  TEXT__TITLE: 'singleActivityDrawer-span-title',
  TEXT__STATUS: 'singleActivityDrawer-span-status',
  TEXT__OUTLET: 'singleActivityDrawer-span-outlet',
  TEXT__DATE_LABEL: 'singleActivityDrawer-span-dateLabel',
  TEXT__DATE: 'singleActivityDrawer-span-date',
  TEXT__DATETIME: 'singleActivityDrawer-span-datetime',
  TEXT__DUE_DATE: 'singleActivityDrawer-span-dueDate',
  TEXT__ACCOUNT_OWNER_DISPLAY: 'singleActivityDrawer-span-accountOwnerDisplay',
  TEXT__ACCOUNT_OWNER_OPTION: 'singleActivityDrawer-span-accountOwnerOption',
  TEXT__ACCOUNT_OWNER: 'singleActivityDrawer-span-accountOwner',
  TEXT__MONEY_SPENT: 'singleActivityDrawer-span-moneySpent',
  TEXT__CONTENT_TITLE: 'singleActivityDrawer-span-contentTitle',
  TEXT__CONTENT_SUBTITLE: 'singleActivityDrawer-span-contentSubtitle',
  TEXT__NOTE: 'singleActivityDrawer-span-note',
  TEXT__SECONDARY_NOTE: 'singleActivityDrawer-span-secondaryNote',
  TEXT__NO_PRODUCTS_TITLE: 'singleActivityDrawer-span-noProductsTitle',
  TEXT__NO_PRODUCTS_INFO: 'singleActivityDrawer-span-noProductsInfo',
  TEXT__CONTACT_INFO: 'singleActivityDrawer-span-contactInfo',
  TEXT__LAST_INVITE_SENT: 'singleActivityDrawer-span-lastInviteSent',
  TEXT__TOTAL_LABEL: 'singleActivityDrawer-span-totalLabel',
  TEXT__TOTAL: 'singleActivityDrawer-span-total',
  ICON__TOTAL_LABEL_INFO: 'singleActivityDrawer-icon-totalLabelInfo',
  ICON__TAX_INCLUDED_INFO: 'singleActivityDrawer-icon-taxIncludedInfo',
  ICON__NOTIFICATION: 'singleActivityDrawer-icon-notification',
  BUTTON__DELETE: 'singleActivityDrawer-button-delete',
  BUTTON__CONTACT_INFO: 'singleActivityDrawer-button-contactInfo',
  BUTTON__ACCOUNT_OPTIONS: 'singleActivityDrawer-button-accountOptions',
  BUTTON__ACTION: 'singleActivityDrawer-button-action',
  BUTTON__INVOICE: 'singleActivityDrawer-button-invoice'
};
exports.SINGLE_ACTIVITY = SINGLE_ACTIVITY;